import { provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { provideToastr } from 'ngx-toastr';
import { ApiInterceptor } from './utils/interceptors';
import { ErrorService } from './shared/services/error.service';
import { constants } from './utils/constants';
import { TranslatePipe, PrefixLangPipe, PrefixSubscriptionPipe, AddressPipe, ApiDomainPipe } from './utils/pipes';
import { CurrencyPipe } from '@angular/common';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';

export const appConfig: ApplicationConfig = {
    providers: [
        // angular
        provideHttpClient(withXhr(), withInterceptors([ApiInterceptor])),
        // plugins
        provideToastr({
            timeOut: 4000,
            extendedTimeOut: 4000,
            positionClass: 'toast-top-center',
            closeButton: false,
            iconClasses: {
                error: 'toast-error',
                info: 'toast-info',
                success: 'toast-success',
                warning: 'toast-warning'
            }
        }),
        provideAppInitializer(() => {
            const tooltipConfig = inject(NgbTooltipConfig);
            tooltipConfig.placement = ['top', 'auto'];
            tooltipConfig.tooltipClass = 'tooltip--simple';
            tooltipConfig.openDelay = 150;
            tooltipConfig.closeDelay = 100;
        }),
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: constants.recaptchaV2Sitekey
            } as RecaptchaSettings
        },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: constants.recaptchaV3Sitekey },
        // error handler
        { provide: ErrorHandler, useClass: ErrorService },
        // pipes
        TranslatePipe,
        PrefixLangPipe,
        PrefixSubscriptionPipe,
        AddressPipe,
        CurrencyPipe,
        ApiDomainPipe
    ]
};
